import { urlApiUser } from '~/utils/constants/apis';
import axiosClient from './axiosClient';
import { IAccountProfile } from '~/utils/interface/auth';
import { IBaseResponse } from '~/utils/interface/base';

// GET /users/profile also serves the mobile apps, so it returns the account
// profile nested under `profile` alongside unrelated sibling data (permissions,
// missed call/voicemail counts...) that the admin web app doesn't use.
const userApi = {
  getProfile() {
    return axiosClient.get<IBaseResponse<{ profile: IAccountProfile }>>(urlApiUser.profile);
  },
};

export default userApi;
